import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/icons/pin.png'


const _hoisted_1 = { class: "image" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { style: {"margin-top":"0.15em"} }
const _hoisted_6 = { style: {"font-size":"0.9em","color":"hsl(215.4 16.3% 46.9%)"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Marker",
  style: {"height":"1em","position":"relative","top":"2px"}
}, null, -1)
const _hoisted_8 = {
  key: 0,
  style: {"margin-top":"0.5em"}
}
const _hoisted_9 = { style: {"font-weight":"bold","margin":"0 0.25em"} }
const _hoisted_10 = { style: {"color":"hsl(215.4 16.3% 46.9%)","font-size":"0.9em"} }
const _hoisted_11 = { class: "details" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "sizes"
}
const _hoisted_14 = { class: "services" }
const _hoisted_15 = { class: "submit" }
const _hoisted_16 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (this.gm !== null)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([{ gm_result_map : this.map }, "gm-result"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: this.gm.images[0].url,
            alt: "Logo {{ this.gm.name }}"
          }, null, 8, _hoisted_2),
          (this.gm.box_promo)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                title: this.TOOLTIP_PROMO,
                class: "promo"
              }, _toDisplayString(this.gm.box_promo), 9, _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, _toDisplayString(this.gm.name), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("i", _hoisted_6, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(this.gm.address) + ", " + _toDisplayString(this.gm.city.name) + " " + _toDisplayString(this.gm.city.postcode) + " (" + _toDisplayString(this.gm.distance) + ") ", 1)
            ])
          ]),
          (this.gm.avis.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "star",
                  style: {"color":"#2562E9"}
                }),
                _createElementVNode("span", _hoisted_9, _toDisplayString(this.gm.note.toFixed( 1 )), 1),
                _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(this.gm.avis.length) + " avis)", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _createVNode(_component_font_awesome_icon, { icon: "cube" }),
            _createTextVNode(" Box à louer de " + _toDisplayString(this.gm.size_range.min) + " à " + _toDisplayString(this.gm.size_range.max) + " " + _toDisplayString(this.gm.size_range.unit), 1)
          ]),
          (this.gm.price > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_font_awesome_icon, { icon: "tag" }),
                _createTextVNode(" À partir de " + _toDisplayString(this.gm.price) + " € / mois ", 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_font_awesome_icon, { icon: "clock" }),
            _createTextVNode(" " + _toDisplayString(this.gm.size_range.all.length) + " tailles disponibles ", 1)
          ])
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.gm.size_range.all, (size, key) => {
                return (_openBlock(), _createElementBlock("div", { key: key }, _toDisplayString(size) + " " + _toDisplayString(this.gm.size_range.unit), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.gm.services, (service, key) => {
            return (_openBlock(), _createElementBlock("div", { key: key }, [
              _withDirectives(_createElementVNode("div", { class: "item" }, _toDisplayString(service), 513), [
                [_vShow, key < 5]
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("a", {
            href: this.gm.url,
            class: "button"
          }, " Infos sur le centre ", 8, _hoisted_16)
        ])
      ], 2))
    : _createCommentVNode("", true)
}